export const mainBaseUrl = process.env.REACT_APP_BASE_URL; // usage in case for {baseURL}/api/v2
export const baseUrl = mainBaseUrl+'/api/v1/';  // defaultBase URl
export const mainBaseUrlDev = process.env.REACT_APP_DEV_BASE_URL;
export const baseUrlDev = mainBaseUrlDev + '/api/v2/'
export const websocketUrl = process.env.REACT_APP_WEBSOCKET_SERVER_URL;
export const pusher_app_key = process.env.REACT_APP_PUSHER_APP_KEY;
export const pusher_app_port = process.env.REACT_APP_PUSHER_PORT;
export const pusher_app_ws_host = process.env.REACT_APP_PUSHER_WS_HOST;
